import styled from 'styled-components';

import { colors, radius } from '../../styles/tokens';

type StatCardAccent = 'primary' | 'secondary' | 'tertiaryContainer';

const accentColor: Record<StatCardAccent, string> = {
  primary: colors.primary,
  secondary: colors.secondary,
  tertiaryContainer: colors.tertiaryContainer,
};

interface ContainerProps {
  accent: StatCardAccent;
}

export const Container = styled.button<ContainerProps>`
  width: 100%;
  min-height: 140px;

  background-color: ${colors.surfaceContainerLow};
  transition: background-color 0.2s;
  border: none;

  &:hover {
    background-color: ${colors.surfaceContainer};
  }

  border-radius: ${radius.md};

  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  overflow: hidden;

  padding: 24px;

  cursor: pointer;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 48px;
    background-color: ${({ accent }) => accentColor[accent]};
  }
`;

export const Title = styled.span`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: ${colors.onSurfaceVariant};
  margin-bottom: 16px;
  text-align: left;
`;

export const DataRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
`;

export const Data = styled.span`
  font-size: 40px;
  font-weight: 800;
  color: ${colors.onSurface};
  text-align: left;
`;

interface TrendProps {
  direction: 'up' | 'down';
}

export const Trend = styled.span<TrendProps>`
  display: flex;
  align-items: center;
  gap: 2px;

  font-size: 13px;
  font-weight: 700;
  margin-bottom: 8px;
  color: ${({ direction }) =>
    direction === 'down' ? colors.error : colors.primary};
`;

export const Note = styled.span`
  font-size: 11px;
  color: ${colors.onSurfaceVariant};
  margin-top: 8px;
  text-align: left;
`;

export const Badge = styled.span`
  padding: 4px 10px;
  margin-bottom: 10px;
  border-radius: ${radius.DEFAULT};

  background-color: ${colors.primary}1a;
  color: ${colors.primary};

  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export type { StatCardAccent };
